import { render } from "./AdminInvoiceTable.vue?vue&type=template&id=648a55d0&scoped=true"
import script from "./AdminInvoiceTable.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceTable.vue?vue&type=script&lang=js"

import "./AdminInvoiceTable.vue?vue&type=style&index=0&id=648a55d0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a55d0"]])

export default __exports__